import {
  AssistantRuntimeProvider,
  useExternalStoreRuntime,
} from "@assistant-ui/react";
import type { Message } from "@circle-react/types/CommunityInbox/Message";
import type { ReactNode } from "react";
import { useMemo } from "react";

import { toAvatarThreadMessages } from "./avatarThreadMessages";

interface AvatarConversationRuntimeProps {
  children: ReactNode;
  isProcessing?: boolean;
  messages: Message[];
}

export const AvatarConversationRuntime = ({
  children,
  isProcessing,
  messages,
}: AvatarConversationRuntimeProps) => {
  const threadMessages = useMemo(
    () => toAvatarThreadMessages(messages),
    [messages],
  );

  const runtime = useExternalStoreRuntime({
    messages: threadMessages,
    isRunning: Boolean(isProcessing),
    convertMessage: message => message,
    // Unreachable: MessageBox still posts on its own.
    onNew: () => Promise.resolve(),
  });

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      {children}
    </AssistantRuntimeProvider>
  );
};
